import { getRequest } from '@bo-apis/axios';

const getLatestPrivacyPolicy = () =>
  getRequest({
    url: '/api/v1/po/system/privacy-policy',
  });

const poPrivacyPolicy = {
  getLatestPrivacyPolicy,
};

export default poPrivacyPolicy;
